// src/store/actions.ts
import { createAction } from "@reduxjs/toolkit";
import { queryClient } from "@/recourses/queryClient";
import {
  AddressEnum,
  CheckoutEnum,
  CreditsEnum,
  PaymentMethodsEnum,
  StoresEnum,
} from "@/recourses/queryKeys";
import { store } from "@/store";
import { ECheckoutSource } from "@/utils/checkoutType";
import { checkoutAction } from "./checkout";

interface EmptyCheckoutOptions {
  source?: ECheckoutSource;
}

const emptyCheckout = createAction("checkout/emptyCheckout", (options?: EmptyCheckoutOptions) => {
  const queryCache = queryClient.getQueryCache();
  const allQueriesCache = queryCache.findAll();

  const queryKeys = [
    "servicePrice",
    AddressEnum.getAddresses,
    StoresEnum.getPickUpStores,
    CheckoutEnum.getQuickStart,
    CheckoutEnum.getAvaliableStores,
    CheckoutEnum.getCartAvailableProducts,
    CheckoutEnum.getShippingInfo,
    PaymentMethodsEnum.paymentsAvailable,
    PaymentMethodsEnum.paymentMethod,
    PaymentMethodsEnum.paymentPseUrl,
    CreditsEnum.creditsAvailable,
    CreditsEnum.referralCreditsAvailable,
  ];

  queryKeys.forEach((query) => {
    const queryhas = allQueriesCache.find((q) => q.queryKey.includes(query));
    if (queryhas) {
      queryClient.removeQueries({
        queryKey: queryhas.queryKey,
        exact: false,
      });
    }
  });

  store.dispatch(checkoutAction.setGift(undefined));
  store.dispatch(checkoutAction.setAdditionalComment(undefined));

  return {
    payload: {
      source: options?.source,
    },
  };
});

export const storeGlobalActions = {
  emptyCheckout,
};
